import type { DbPortalChecklistePunkt, DbPortalChecklisteStatus, DbPortalStandort } from '@gql/shared-types';

export const STATUS_TEXT: Record<DbPortalChecklisteStatus, string> = {
  fehlt: 'fehlt',
  geliefert: 'geliefert',
  geprueft: 'geprüft',
  nicht_vorhanden: 'liegt nicht vor',
};

export const ZUORDNUNG_TEXT: Record<DbPortalStandort['zuordnungArt'], string> = {
  manuell: 'von GQL zugeordnet',
  angabe: 'nach Ihrer Angabe',
  koordinaten: 'nach Koordinaten',
  ortsname: 'nach Ortsname',
  plz: 'nach Postleitzahl',
  offen: 'noch nicht zugeordnet',
};

export function punktTitel(p: Pick<DbPortalChecklistePunkt, 'art' | 'jahr'>): string {
  if (p.art === 'vertrag') return 'Vertrag';
  if (p.art === 'leistungsbeschreibung') return 'Leistungsbeschreibung';
  if (p.art === 'agb') return 'AGB / Vertragsbedingungen';
  if (p.art === 'entgeltaenderung') return 'Entgeltänderungen seit Vertragsbeginn';
  return `Rechnung ${p.jahr}`;
}

export function fortschrittText(s: Pick<DbPortalStandort, 'fortschritt'>): string {
  const f = s.fortschritt;
  return f.vollstaendig ? 'vollständig' : `${f.erledigt} von ${f.pflicht} erledigt`;
}

export function adresse(s: Pick<DbPortalStandort, 'strasse' | 'plz' | 'ort'>): string {
  return [s.strasse, [s.plz, s.ort].filter(Boolean).join(' ')].filter(Boolean).join(', ') || '–';
}

/** Liest eine CSV-Datei: UTF-8, sonst Windows-1252 (Excel speichert „CSV“ oft so). */
export async function leseCsvDatei(datei: File): Promise<string> {
  const puffer = await datei.arrayBuffer();
  try {
    return new TextDecoder('utf-8', { fatal: true }).decode(puffer);
  } catch {
    return new TextDecoder('windows-1252').decode(puffer);
  }
}
